import React, { useEffect } from 'react';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import IntroSection from '../Common/IntroSection';
import { useLocation } from 'react-router';
import AnimatedSection from '../Common/AnimatedSection';
import { ServiceDetail } from '../../const/ServiceInfo';
import ServiceOverview from './ServiceOverview';
import ServiceBenefits from './ServiceBenefits';
import ServiceSymptoms from './ServiceSymptoms';
import ServiceTreatment from './ServiceTreatment';
import ServiceAftercare from './ServiceAftercare';
import ServiceFAQ from './ServiceFAQ';
import ServiceTestimonials from './ServiceTestimonials';
import ServiceBeforeAfterComparison from './ServiceBeforeAfterComparison';
import ServiceRelated from './ServiceRelated';
import ServicePartnerInstruction from '../Common/ServicePartnerInstruction';

function ServiceDetails() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const location = useLocation()
  const page = location.pathname.substring(1)

  return (
    <div className="about">
      <AnimatedSection id='intro' delay={200}>
        <IntroSection 
          title={ServiceDetail[page].title} 
          about={ServiceDetail[page].tagline} />
      </AnimatedSection>

      <AnimatedSection id='overview' delay={400}>
        <ServiceOverview overview={ServiceDetail[page].overview} serviceName={page} />
      </AnimatedSection>

      <AnimatedSection id='benefits' delay={600}>
        <ServiceBenefits benefits={ServiceDetail[page].benefits} />
      </AnimatedSection>

      <AnimatedSection id='symptom' delay={800}>
        <ServiceSymptoms symptoms={ServiceDetail[page].symptoms} />
      </AnimatedSection>

      {/* <AnimatedSection id='treatment' delay={1000}>
        <ServiceTreatment treatment={ServiceDetail[page].treatment} />
      </AnimatedSection> */}

      {
        ServiceDetail[page].servicePartnerInstruction && (
          <AnimatedSection id='servicePartnerInstruction' delay={1200}>
            <ServicePartnerInstruction />
          </AnimatedSection>
        )
      }

      {/* <AnimatedSection id='aftercare' delay={1200}>
        <ServiceAftercare aftercare={ServiceDetail[page].aftercare} />
      </AnimatedSection> */}

      <AnimatedSection id='servicefaq' delay={1400}>
        <ServiceFAQ faq={ServiceDetail[page].faq} serviceName={page} />
      </AnimatedSection>

      {/* <AnimatedSection id='servicebeforeafter' delay={1600}>
        <ServiceBeforeAfterComparison />
      </AnimatedSection> */}

      <AnimatedSection id='servicetestimonials' delay={1800}>
        <ServiceTestimonials testimonials={ServiceDetail[page].testimonials} />
      </AnimatedSection>

      <AnimatedSection id='service' delay={2000}>
        <ServiceRelated services={ServiceDetail[page].relatedservices} serviceName={page} />
      </AnimatedSection>

      <AnimatedSection id='visitUs' delay={1200}>      
        <VisitUsSection />
      </AnimatedSection>

      <AnimatedSection id='bookVisit' delay={1400}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default ServiceDetails;